import { ReactNode, useEffect, useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface AnimatedCardProps {
  children: ReactNode;
  alignment?: 'left' | 'right' | 'center';
  delay?: number;
  className?: string;
}

export const AnimatedCard = ({ 
  children, 
  alignment = 'center',
  delay = 0,
  className = ''
}: AnimatedCardProps) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShouldAnimate(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [isVisible, delay]);

  const getAlignmentClasses = () => {
    switch (alignment) {
      case 'left':
        return 'md:mr-auto md:ml-0';
      case 'right':
        return 'md:ml-auto md:mr-0';
      default:
        return 'mx-auto';
    }
  };

  const getAnimationClasses = () => {
    if (shouldAnimate) {
      return 'opacity-100 translate-x-0';
    }
    
    switch (alignment) {
      case 'left':
        return 'opacity-0 -translate-x-10';
      case 'right':
        return 'opacity-0 translate-x-10';
      default:
        return 'opacity-0 translate-y-10';
    }
  };

  return (
    <div
      ref={ref}
      className={`
        w-full md:w-3/4 
        ${getAlignmentClasses()}
        transition-all duration-700 ease-out
        ${getAnimationClasses()}
        ${className}
      `}
    >
      {children}
    </div>
  );
};
